const DEFAULT_APP_BASE_NAME = "T3 Code";
const DEFAULT_APP_SERVER_NAME = `${DEFAULT_APP_BASE_NAME} Server`;
export const APP_SERVER_NAME = typeof __APP_SERVER_NAME__ === "string" ? __APP_SERVER_NAME__ : DEFAULT_APP_SERVER_NAME;
